import { ReactNode, useCallback, useState, MouseEvent } from 'react'

import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'

import {
  PlainDropDownSurfaceCommon,
  SurfaceType,
  AreaProps,
  SurfacePlacement,
} from '../plain-dropdown-surface-common'

import styles from './plain-popup-id-to-clipboard.module.scss'
import PlainButtonAsLink from '../plain-button-as-link'

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const PlainPopupIdToClipboard = ({
  id,
  children,
  onError,
  onSuccess,
}: {
  id: string
  children: (
    onClick: (event: MouseEvent<HTMLElement>) => void,
    opened: boolean,
    areaProps: AreaProps,
  ) => ReactNode
  onError?: () => void
  onSuccess?: () => void
}) => {
  const [pending, setPending] = useState(false)

  const handleCopy = useCallback(async () => {
    try {
      setPending(true)
      await navigator.clipboard.writeText(id)
      onSuccess?.()
      await delay(300)
    } catch (err) {
      console.error('Не удалось скопировать в буфер', err)
      onError?.()
    } finally {
      setPending(false)
    }
  }, [id, onError, onSuccess])

  return (
    <PlainDropDownSurfaceCommon
      id={`id_info_${id}`}
      type={SurfaceType.Dialog}
      placement={SurfacePlacement.CursorTopRight}
      surfaceContent={() => (
        <div className={styles.surface}>
          <div>
            <span className={styles.title}>{'ID: '}</span>
            <span>{id}</span>
          </div>
          <PlainButtonAsLink onClick={handleCopy}>
            <PlainIcon
              type={iconType.CLIPBOARD_COPY}
              color={pending ? iconColor.COLOR_LIGHTGRAY : iconColor.COLOR_PRIMARY}
            />
          </PlainButtonAsLink>
        </div>
      )}
    >
      {(...args) => children(...args)}
    </PlainDropDownSurfaceCommon>
  )
}
